const CompanyIncludesList = [
  'city',
  'contact',
  'createdBy',
  'hiringAuthorities',
  'phones',
  'recruiter',
  'specialties',
  'specialty',
  'subspecialties',
  'subspecialty',
  'type'
];
export const CompanyIncludes = CompanyIncludesList.join(',');

const CandidateIncludesList = [
  'additionalRecruiters',
  'blueSheets',
  'createdBy',
  'emailValidation',
  'optOutStatus',
  'personalEmailValidation',
  'personalInformation',
  'phones',
  'position',
  'recruiter',
  'relation',
  'sourceType',
  'specialty',
  'status',
  'subStatus',
  'subspecialty'
];
export const CandidateIncludes = CandidateIncludesList.join(',');

const JobOrderIncludesList = [
  'additionalRecruiters',
  'address',
  'createdBy',
  'hiringAuthorities',
  'position',
  'recruiter',
  'sourceType',
  'specialty',
  'status',
  'subspecialty',
  'whiteSheet'
];
export const JobOrderIncludes = JobOrderIncludesList.join(',');

const ContactIncludesList = [
  'createdBy',
  'emailValidation',
  'personalEmailValidation',
  'personalInformation',
  'phones',
  'position',
  'sourceType',
  'specialty',
  'status',
  'subStatus',
  'subspecialty'
];
export const ContactIncludes = ContactIncludesList.join(',');

const HiringAuthorityIncludesList = [
  'company',
  'createdBy',
  'emailValidation',
  'hiringAuthorityStatus',
  'lastActivityLog',
  'optOutStatus',
  'personalEmailValidation',
  'phones',
  'position',
  'recruiter',
  'relation',
  'specialty',
  'status',
  'subspecialty',
  'subStatus'
];
export const HiringAuthorityIncludes = HiringAuthorityIncludesList.join(',');
